import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';
import { toSelect } from 'utils/genericFunctions';
import { Types, ConsultarFuncionalidade } from './types';

export const INITIAL_STATE: ConsultarFuncionalidade = {
	status: 0,
	data: null,
	enum: [],
	totalRegistrosConsulta: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarFuncionalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_FUNCIONALIDADES_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				draft.enum = INITIAL_STATE.enum;
				break;
			}

			case Types.CONSULTAR_FUNCIONALIDADES_SUCCESS: {
				draft.enum = toSelect(action.payload.data, 'descricao', 'id');
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				draft.totalRegistrosConsulta =
					action.payload.headers['x-num-registros'];
				break;
			}

			case Types.CONSULTAR_FUNCIONALIDADES_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_FUNCIONALIDADES_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				draft.enum = INITIAL_STATE.enum;
				break;
			}

			default:
		}
		return draft;
	});
}
